/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultCreateCredential } from "../../funcs/llmMcpVaultCreateCredential.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateMcpCredentialRequest$inboundSchema,
};

export const tool$llmMcpVaultCreateCredential: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-create-credential",
  description: `Create MCP credential

Stores encrypted credentials for a user-owned MCP server. Secret values are never returned.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultCreateCredential(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
